export type FaqLink = { slot: string; labelKey: string; href: string };
export type FaqParagraph = {
  key: string;
  bold?: Record<string, string>;
  values?: Record<string, string>;
  link?: FaqLink;
};
export type FaqItem = { id: string; answer: FaqParagraph[] };
export type FaqGroup = { id: string; items: FaqItem[] };

export const faqPara = (key: string, bold?: Record<string, string>): FaqParagraph => (bold ? { key, bold } : { key });
export const faqLead = (key: string): FaqParagraph => faqPara(key, { lead: `${key}Lead` });
